<template>
  <div>
    <div style="background-color: #fafafa; height: 100vh; display: flex; align-items: center;">
      <b-container>
        <b-row>
          <b-col sm="11" md="6" offset-md="3">
            <section class="complete-body">
              <h1>할인 패키지 구매 완료!
                <br>지금 무료체험 중인 제품의
                <br><b>결제일에는 0원이 결제됩니다.</b>
              </h1>
              <img style="margin-top: 57px; width: 317px;" src="@/assets/promotion/promotion-payment-info.png" alt="">
            </section>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <app-footer></app-footer>
  </div>
</template>
<script>
import countTo from 'vue-count-to'
import AppFooter from '../AppFooter'

export default {
  name: 'promotion-complete',
  components: { countTo, AppFooter },
  data () {
    return {
      number: ''
    }
  },
  computed: {
    campaignCustomerId () {
      return this.$store.state.campaignCustomerId
    },
    campaignCustomerName () {
      return this.$store.state.campaignCustomerName
    },
    campaignPaymentAmount () {
      return Number(this.$store.state.campaignPaymentAmount) * 1.5
    }
  }
}
</script>
<style scoped>

.complete-body h1 {
  font-size: 18px;
  font-weight: 500;
  letter-spacing: -0.5px;
}

.hidden {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/promotion/promotionComplete.vue